import { useNavigate, useSearch } from '@tanstack/react-router';

import { OverviewCustomerCompanySelect } from '../../../common/form-elements/CompanySelect/OverviewCustomerCompanySelect';
import { OverviewSupplierCompanySelect } from '../../../common/form-elements/CompanySelect/OverviewSupplierCompanySelect';
import { Box } from '../../../common/ui/Box';

export const AssignmentsFilterSelects = () => {
    const navigate = useNavigate({ from: '/assignments' });
    const search = useSearch({ from: '/_app/assignments' });

    return (
        <Box display="flex" gap={8}>
            <OverviewCustomerCompanySelect
                onChange={(customerIds) => {
                    navigate({
                        search: (previousSearch) => ({
                            ...previousSearch,
                            customerIds,
                            page: 0,
                        }),
                    });
                }}
                value={search.customerIds}
            />

            <OverviewSupplierCompanySelect
                value={search.supplierIds}
                onChange={(supplierIds) => {
                    navigate({
                        search: (previousSearch) => ({
                            ...previousSearch,
                            supplierIds,
                            page: 0,
                        }),
                    });
                }}
            />
        </Box>
    );
};
